<script>
import { Line } from "vue-chartjs"

export default {
  extends: Line,
  mounted() {
    const data = {
      labels: [
        ["15-2", "✓"],
        ["16-1", "✓"],
        ["16-2", "?"],
        ["17-1", "✓"],
        ["17-2", "✓"],
        ["18-1", "✓"],
        ["18-2", "✓"],
        ["19-1", "✓"],
        ["19-2", "-"]
      ],
      datasets: [
        {
          data: [100, 78, null, 75, 25, 80, 70, 90],
          backgroundColor: "rgba(189, 229, 232, 1)",
          borderColor: "rgba(211, 234, 225, 1)",
          borderWidth: 0,
          lineTension: 0,
          pointRadius: 0,
          spanGaps: false
        }
      ]
    }
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        intersect: false
      },
      layout: {
        padding: {
          left: 50,
          right: 50,
          top: 0,
          bottom: 0
        }
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            ticks: {
              min: 0,
              max: 100,
              stepSize: 25,
              // Include a dollar sign in the ticks
              callback: function(value, index, values) {
                return value + "%"
              }
            },
            gridLines: {
              display: true,
              drawBorder: false,
              color: "rgba(242, 242, 242, 1)"
            }
          }
        ]
      }
    }

    // this.addPlugin({
    //   id: "my-plugin",
    //   beforeInit: function(chart, options) {
    //     console.log("hehehe");
    //     chart.legend.afterFit = function() {
    //       this.height = this.height + 10;
    //     };
    //   }
    // });

    this.renderChart(data, options)
  }
}
</script>
